import { combineReducers } from 'redux';

import AuthManager from './AuthManager';

const reducer = combineReducers({
  AuthManager
})

export default reducer;